import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

function withChangeAvatar() {
  const AvatarContext = React.createContext({});

  const AvatarProvider = ({ children }) => {
    const originalAvatarURL = useSelector(
      ({
        user: {
          user: { photoURL = '' },
        },
      }) => photoURL,
    );

    const [avatarURL, setAvatarURL] = useState(originalAvatarURL);

    const resetAvatarURL = () => setAvatarURL(originalAvatarURL);

    useEffect(() => {
      setAvatarURL(originalAvatarURL);
    }, [originalAvatarURL]);

    const value = {
      avatarURL,
      setAvatarURL,
      resetAvatarURL,
    };

    return (
      <AvatarContext.Provider value={value}>{children}</AvatarContext.Provider>
    );
  };

  AvatarProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };

  const useChangeAvatar = () => useContext(AvatarContext);

  return {
    AvatarProvider,
    useChangeAvatar,
  };
}

export const { AvatarProvider, useChangeAvatar } = withChangeAvatar();
